<template>  
  <modal v-model="show"
         max-width="400"
         content-class="modal-device"        
         :has-padding="false">    

    <button class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="reset">
      {{$t('message.coupons.message.registerCoupon')}}
    </button>

    <div :key="id">

      <app-promocional-code-form ref="body"
                                 v-model="data"
                                 @input="input"
                                 @valid="save"></app-promocional-code-form>

      <div class="card-footer">
        <button class="btn btn-primary btn-round"
                @click="validate()">
          {{$t('message.generics.message.register')}}
        </button>
      </div>

    </div>
  </modal>  
</template>

<script>
    import AppPromocionalCodeForm from './components/PromocionalCodeForm'
    import EventBus from '@packages/event-bus'
    import Modal from "@/components/generic/Modal";

    export default {
        components: {
            AppPromocionalCodeForm,
            Modal
        },

        data() {
            return {
                show: false,
                id: null,
                data: {
                },
            }
        },

        computed: {
            devices() {
                return this.$store.state.devices.list
            },

        },

        methods: {
            validate() {
                this.$refs.body.validate()
            },


            async save() {
                let res = await this.$api.promocionalcode.create(this.data)
                EventBus.$emit('show-message', {
                    type: 'SUCCESS',
                    message: res.message,
                    timeout: 2000
                })
                EventBus.$emit(`LOAD_PROMOCIONAL_CODE`)
                this.show = false
            },

            reset() {
                this.data = {
                    codigo: '',
                    localId: ''
                }
            },

            input(value) {
                this.data = value
            },
            hideModal() {
                this.emitInput(false);
            },
        },

        watch: {
            show(show) {
                if (show)
                    this.$nextTick(() => EventBus.$emit('RESET_FREECONNECTIONS_MODAL'))
            }
        },

        mounted() {
        },
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.modal-round .v-card .card-body {
  min-height: 200px;
}
</style>
